
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function SkipContentAccessibility() {
  const { t  } = useTranslation();
  const [focused, setFocused] = useState(false);

  return (
    <a
      role="button"
      href="#main-content"
      aria-label={ t("skip_content") }
      tabIndex={ 0 }
      onFocus={ () => setFocused(true) }
      onBlur={ () => setFocused(false) }
      style={ {
        position: focused ? "static" : "absolute",
        width: focused ? "1px" : "1px",
        height: focused ? "1px" : "1px",
        overflow: focused ? "visible" : "hidden",
        clip: focused ? "auto" : "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap"
      } }
    >
    </a>
  );
}
